import React from 'react';
import Executive from '../../dropdown/executive';
import { Grid, Icon } from 'semantic-ui-react';
import Server from '../../../functions/server';
import $ from "jquery";
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Viewhistory from './viewhistory';
import Loading from '../../loading';

class History extends React.Component {

  state = {
    history: []
  }

  update(type, value, data) {
    this.setState({
      selectedExecutive: value,
      executiceData: data
    });
  }

  getHistory(date) {
    let context = this;
    let data1 = { 'executive': this.state.selectedExecutive, 'date': date };
    this.setState({ load: true, message: 'Getting history!!!' })
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'login/history.php',
      success: function(data)
      {
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          context.setState({ history: data })
        } catch (e) {

        }
      },
      error: function(e)
      {
        console.log(e);
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
    this.getHistory(event.target.value);
  };

  separateHistory() {
    let data = this.state.history;

    let item = [];
    let invalue = 1;
    let outvalue = 1;
    data = this.sortByKey(data)
    data.map((c) => {
      if (c.action == "IN") {
        if (invalue == 1) {
          item.push(c);
          invalue = 0;
          outvalue = 1;
        }
      }
      else if (c.action == "OUT") {
        if (outvalue == 1) {
          item.push(c);
          invalue = 1;
          outvalue = 0;
        }
      }
      else {

      }
    });

    let inAction;
    let inTime;
    let outTime;
    let outAction;
    let outVal = 1;
    let inVal = 1;
    let length = item.length;
    let it = [];
    let c = 1;
    for (var i = 0; i < item.length; i++) {
      if (item[i].action == 'IN') {
        if (inVal == 1) {
          inAction = item[i].action;
          inTime = item[i].timestamp;
          inVal = 0;
          outVal = 1;
          it.push({ id: c, inaction: inAction, intime: inTime })
        }
      }
      else if (item[i].action == 'OUT') {
        for (var j = 0; j < item.length; j++) {
          if (item[i].action == 'OUT') {
            if (outVal == 1) {
              outAction = item[i].action;
              outTime = item[i].timestamp;
              outVal = 0;
              inVal = 1;
              for (var k = 0; k < it.length; k++) {
                if (it[k].id == c) {
                  it[k].outaction = outAction;
                  it[k].outtime = outTime;
                }
              }
              c = c + 1;
            }
          }
        }
      }
      else {

      }
    }
    let newData = this.sort(it);
    return newData;
  }

  sort(data) {
    data.sort(function(a,b){
      return new Date(b.id) - new Date(a.id);
    });

    return data;
  }

  sortByKey(data) {
    data.sort(function(a,b){
      return new Date(a.timestamp) - new Date(b.timestamp);
    });

    return data;
  }

  render() {
    let  i = 0;
    let data = this.separateHistory();
    return (
      <div style={{height: 600}}>
      <Loading load={this.state.load} message={this.state.message} />
        <br/>
        <Grid style={{paddingLeft: '2%'}}>
          <Grid.Column mobile={16} tablet={16} computer={6}>
            Select Executive<br/>
            <Executive update={this.update.bind(this)} />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={6}>
            Select Date<br/>
            <input type="date"  id="date" value={this.state.date}
              style={{width: '100%', height: 25 }} onChange={this.handleChange('date')} />
          </Grid.Column>
        </Grid>
        <br/>
        <div style={{padding: '2%'}}>
          <table id="table" width="100%">
            <tr>
              <th id="tableheader" style={{width: '15%'}}><center>Sino</center></th>
              <th id="tableheader" style={{width: '35%'}}><center>Login</center></th>
              <th id="tableheader" style={{width: '35%'}}><center>Logout</center></th>
              <th id="tableheader" style={{width: '15%'}}><center>View</center></th>
            </tr>
            { data.map((m) => {
                i++;
                return (
                  <tr>
                    <td><center>{i}</center></td>
                    <td><center>{m.intime}</center></td>
                    <td><center>{m.outtime}</center></td>
                    <td id="pointer"><center><Viewhistory inTime={m.intime} outTime={m.outtime} data={this.state.history} /></center></td>
                  </tr>
                )
              })
            }
          </table>
        </div>
      </div>
    );
  }
}

export default History;
